import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCategoryFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 18.75a1.25 1.25 0 1 1 0 2.5H2a1.25 1.25 0 0 1 0-2.5zm3.751-9.25a4.25 4.25 0 1 0-8.5 0 4.25 4.25 0 0 0 8.5 0M6 12.25a1.25 1.25 0 1 1 0 2.5H2a1.25 1.25 0 0 1 0-2.5zm0-6.5a1.25 1.25 0 0 1 0 2.5H2a1.25 1.25 0 1 1 0-2.5zM21.251 9.5a6.7 6.7 0 0 1-1.12 3.722l2.894 2.894a1.25 1.25 0 0 1-1.767 1.768l-2.87-2.87a6.7 6.7 0 0 1-3.887 1.236 6.75 6.75 0 1 1 6.75-6.75"
  }));
}
var IcCategoryFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCategoryFill));

export { IcCategoryFill as I };
